module.exports = __webpack_public_path__ + "static/media/NewProject.7637af2b.gif";